import { axiosInstanceAuth } from "./setup";

export interface IHealthAreaItem {
  id: number;
  name: string;
  icode: string;
  isPublished: boolean;
}

interface IHealthAreaApiResponseData {
  status: string;
  data: IHealthAreaItem[];
}

interface IHealthAreaApiResponse {
  status: number;
  data: IHealthAreaApiResponseData;
}

export interface IFilters {
  measure_type: boolean,
  race: boolean,
  sex: boolean,
  age: boolean,
}

export const handleGetHealthAreaCategories = async (): Promise<IHealthAreaApiResponse> => {
  return axiosInstanceAuth().get(`/admin/fetch_health_categories`);
};

export const handleCreateHealthAreaCategory = async (formData: any): Promise<IHealthAreaApiResponse> => {
  return axiosInstanceAuth().post(`/admin/create_health_category`, formData);
};

export const handleUpdateHealthAreaCategory = async (
  id: number,
  name: string,
  icode: string,
): Promise<IHealthAreaApiResponse> => {
  return axiosInstanceAuth().put(`/admin/update_health_category`, { id, name, icode });
};

export const handlePublishHealthAreaCategory = async (
  id: number,
): Promise<IHealthAreaApiResponse> => {
  return axiosInstanceAuth().patch(`/admin/publish_health_category`, { id });
};

export const handleDeleteHealthAreaCategory = async (id: string): Promise<void> => {
  const result = await axiosInstanceAuth().delete("/admin/delete_health_category", {
    data: { id: parseInt(id) },
  });
  return result.data;
};

export enum DataType {
  Incidence = "incidence",
  Prevalence = "prevalence",
}

export interface IDiseaseFormData {
  id?: number;
  name: string;
  prevalenceReference: string,
  icode: string;
  source: string;
  sourceYear: number;
  disclaimer: string;
  dataType: DataType;
  healthAreaCategoryId: number;
  filters: IDiseaseFilters;
}

export interface IDiseaseItem {
  id: number;
  name: string;
  prevalenceReference: string,
  icode: string;
  source: string;
  sourceYear: number;
  disclaimer: string;
  dataType: DataType;
  healthAreaCategoryId: number;
  filters: IDiseaseFilters;
  HealthAreaCategory: IHealthAreaItem;
}

export interface IDiseaseFilters {
  measure_type: boolean;
  race: boolean;
  age: boolean;
  sex: boolean;
}

export interface IDiseaseApiResponseData {
  status: string;
  data: IDiseaseItem[];
}

export interface IDiseaseApiResponse {
  status: number;
  data: IDiseaseApiResponseData;
}

export const handleGetDiseaseBurdens = async (): Promise<IDiseaseApiResponse> => {
  return axiosInstanceAuth().get(`/admin/fetch_disease_burdens`);
};

interface IHandleCreateDiseaseBurdenFromData {
  id?: number;
  name: string;
  icode: string;
  diseases: IDiseaseItem[],
}

export const handleCreateDiseaseBurden = async (
  formData: IHandleCreateDiseaseBurdenFromData
): Promise<IDiseaseApiResponse> => {
  return axiosInstanceAuth().post(`/admin/create_disease_burden`, formData);
};

export const handleUpdateDiseaseBurden = async (
  id: number,
  name: string,
  prevalenceReference: string,
  icode: string,
  source: string,
  sourceYear: number,
  disclaimer: string,
  dataType: DataType,
  healthAreaCategoryId: number,
  filters: IFilters,
): Promise<IDiseaseApiResponse> => {
  return axiosInstanceAuth().put(`/admin/update_disease_burden`, {
    id, name, prevalenceReference, icode, source, sourceYear, disclaimer, dataType, healthAreaCategoryId, filters,
  });
};

export const handleDeleteDiseaseBurden = async (id: number): Promise<IDiseaseApiResponse> => {
  const result = await axiosInstanceAuth().delete("/admin/delete_disease_burden", {
    data: { id },
  });
  return result.data;
};
